import React from "react";
import TopupStatusTemplate from "../../../components/topup/TopupStatusTemplate/TopupStatusTemplate";
import ImageExclamationTriangle from "../../../images/exclamation-triangle.png";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../../utils/renderHeaders";
import { useNavigate } from "react-router-dom";
import { ROUTES, usePlayGameMetaDescription } from "../../../utils/constants";
import { useTranslation } from "react-i18next";

export default function TopupFailed() {
  const navigate = useNavigate();
  const metaDescriptions = usePlayGameMetaDescription();
  const { t } = useTranslation();

  return (
    <>
      {renderHeaders({
        title: t("metadata:failed_top_up_hyper_gaming_app"),
        description: metaDescriptions.generic,
        ogTitle: extractOgTitleFromMainTitle(
          t("metadata:failed_top_up_hyper_gaming_app")
        ),
      })}

      <TopupStatusTemplate
        image={ImageExclamationTriangle}
        mainCopy="Transaction failed"
        subCopy="We're sorry about that. Let's retry your transaction."
        handlePrimaryAction={() => navigate(ROUTES.WALLET.TOPUP)}
      />
    </>
  );
}
